import React from 'react';
import SbEditable from 'storyblok-react';

import { renderStoryblokRichText } from '../../../utils/renderStoryblokRichText';
import { StoryDetails } from '../StoryDetails/StoryDetails';

type Props = {
  blok: TextArea;
};

const Text: React.FC<Props> = ({ blok }) => {
  return (
    // padding-bottom is 6px to account for 18px of paragraph padding
    <div className="grid-section md:pb-2">
      <div className="col-span-3 hidden md:block" />
      {/* @ts-expect-error require storyblok-react upgrade */}
      <SbEditable key={blok._uid} content={blok}>
        <div className="textArea col-span-12 md:col-span-6">
          {blok.heading && (
            <span className="inline-block w-full pb-4 font-bold">
              {blok.heading}
            </span>
          )}
          {blok.text && renderStoryblokRichText(blok.text)}
        </div>
      </SbEditable>
      {blok.aside ? (
        <aside className="col-span-12 mb-4 text-neutral-4 md:col-span-3 md:col-start-10">
          {renderStoryblokRichText(blok.aside)}
        </aside>
      ) : blok.details?.length ? (
        <div className="col-span-12 md:col-span-3">
          {blok.details.map((details) => (
            <StoryDetails key={details._uid} details={details} />
          ))}
        </div>
      ) : (
        <div className="col-span-3 hidden md:block" />
      )}
    </div>
  );
};

export default Text;
